import { useQuery } from 'react-query';
import { customerResponse } from 'src/models/CRM';
import { fetchCustomers } from 'src/services/CRM/customers';

export default function useCustomers(search?: string) {
  return useQuery<customerResponse[]>(['customers', search], () => fetchCustomers(search));
}
